import { render, staticRenderFns } from "./List-Report.vue?vue&type=template&id=0f18dd95"
import script from "./List-Report.vue?vue&type=script&lang=js"
export * from "./List-Report.vue?vue&type=script&lang=js"
import style0 from "./List-Report.vue?vue&type=style&index=0&id=0f18dd95&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports